import { render } from "./AppInputBase.vue?vue&type=template&id=0cd86e7a&scoped=true&ts=true"
import script from "./AppInputBase.vue?vue&type=script&lang=ts"
export * from "./AppInputBase.vue?vue&type=script&lang=ts"

import "./AppInputBase.vue?vue&type=style&index=0&id=0cd86e7a&lang=postcss&scoped=true"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd86e7a"]])

export default __exports__